import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RfhColors } from '../../config/florimixColors'
import { useTransactionSelection } from '../../context/transactionSelectionContext'

type TransactionDownloadBarProps = {
  onDownload: () => void
  isLoading?: boolean
  count?: number
}

export const TransactionDownloadBar = ({
  onDownload,
  isLoading = false,
  count,
}: TransactionDownloadBarProps) => {
  const { t } = useTranslation()
  const { selectedCount } = useTransactionSelection()
  const displayCount = count ?? selectedCount

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: theme => theme.zIndex.appBar - 1,
        display: 'flex',
        justifyContent: 'flex-end',
        px: 2,
        py: 1,
        backgroundColor: RfhColors.white,
      }}
    >
      <Button
        variant='contained'
        disabled={displayCount === 0 || isLoading}
        onClick={onDownload}
        fullWidth
        sx={{
          backgroundColor: RfhColors.dutchOrange,
          color: RfhColors.white,
          fontWeight: 700,
        }}
      >
        {t('transactions.toolbar.download', { count: displayCount })}
      </Button>
    </Box>
  )
}
